var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 8,
    fill: "#898989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82273 5.696H9.83473C10.6587 5.696 11.2747 5.868 11.6827 6.212C12.0987 6.548 12.3067 7.08 12.3067 7.808C12.3067 8.328 12.2147 8.736 12.0307 9.032C11.8547 9.32 11.5907 9.548 11.2387 9.716C12.1187 10.02 12.5587 10.672 12.5587 11.672C12.5587 12.504 12.3387 13.1 11.8987 13.46C11.4587 13.82 10.8227 14 9.99073 14H6.82273V5.696ZM9.89473 10.184H7.74673V13.184H9.95473C10.4987 13.184 10.9107 13.072 11.1907 12.848C11.4787 12.616 11.6227 12.212 11.6227 11.636C11.6227 11.332 11.5627 11.076 11.4427 10.868C11.3307 10.66 11.1787 10.512 10.9867 10.424C10.6347 10.264 10.2707 10.184 9.89473 10.184ZM9.79873 6.512H7.74673V9.38H9.88273C10.3947 9.38 10.7667 9.26 10.9987 9.02C11.2387 8.772 11.3587 8.404 11.3587 7.916C11.3587 7.42 11.2307 7.064 10.9747 6.848C10.7267 6.624 10.3347 6.512 9.79873 6.512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/B.98f514fad16a18f5bb1d1d2f42fd38c2.svg";
export { ForwardRef as ReactComponent };